import React from "react";

import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import { Drawer } from "@material-ui/core";
import SignUp from "../common/SignUp";

function SimpleDrawer({ open, onClose, language }) {
  return (
    <Drawer
      anchor="bottom"
      classes={{
        paperAnchorBottom: language == "arabic" ? "left-auto" : "",
      }}
      open={open}
      onClose={() => onClose()}
      PaperProps={{
        style: {
          minHeight: 100,
          height: "auto",
          width: "100%",
        },
        className: "text-center",
      }}
      onBackdropClick={() => onClose()}
    >
      <h3
        style={{
          fontFamily: "Quicksand, Cairo",
          marginTop: 30,
          marginBottom: 0,
          direction: language == "english" ? "ltr" : "rtl",
        }}
      >
        {language == "english" ? "Join now!" : "انضم الآن!"}
      </h3>
      <SignUp hideSignUpButton />
      <Button
        variant="contained"
        color="primary"
        onClick={() => onClose()}
        style={{
          width: "97%",
          height: 45,
          fontSize: "1rem",
          boxShadow: "none",
          textTransform: "none",
          margin: "auto",
          marginBottom: 8,
          marginTop: 15,
        }}
        dir={language == "english" ? "ltr" : "rtl"}
      >
        {language == "english" ? "Close" : "اغلاق"}
      </Button>
    </Drawer>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    cart: state.cart.cart,
    promo_items: state.cart.promo_items,
    user: state.auth.user,
    pages: state.staticPages.pages,
    settings: state.store.store.settings,
  };
};
export default withRouter(connect(mapStateToProps)(SimpleDrawer));
